/*
 * !!!Warning!!!
 * This component has been copied from ../../../../main/src/components/SocialSharingList
 * If any changes are to be made in this file, it should also be made in the original
 */

import React from "react";

const GetName = ({ name }) => {
    if (name === "twitter") {
        return "X/Twitter";
    }
    else {
        return name.charAt(0).toUpperCase() + name.slice(1);
    }
}

const SocialSharingList = ({ url, name }) => (
    <li>
        <a href={url} className={name.toLowerCase()} target="_blank">
            {GetName({name})}
        </a>
    </li>
);

export default SocialSharingList;
